import React from 'react'
import TextLabel from './TextLabel'
import { t } from 'i18next'
function PickupTarget({ minuteToCalculate }) {
  const minutesToHHMMSS = (minutes) => {
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    // let seconds = remainingMinutes * 60;
    let seconds = '00';
    hours = hours>10?hours:'0'+hours;
    remainingMinutes = remainingMinutes>10?remainingMinutes:'0'+remainingMinutes;
    return `${hours}:${remainingMinutes}:${seconds}`;
  }
  return (
      <TextLabel title={t("general.lable.pickUpTarget") + `(HH:MM:SS): ${minutesToHHMMSS(minuteToCalculate)}`} />
  )
}

export default PickupTarget